"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetBucketService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const cps_consensus_1 = require("@branch-ts/cps-consensus");
const practice_cps_web_1 = require("@branch-ts/practice-cps-web");
const verset_consensus_1 = require("@project/verset_consensus");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
const MaxImageSize = 1024 * 1024 * 10;
let VersetBucketService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetBucketService = class {
        static { _classThis = this; }
        constructor() {
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
            });
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetBucketService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        get server() {
            return this.deps.VersetRequireLoginService.server;
        }
        assertImageFile(file) {
            if (!file.type.toLowerCase().startsWith("image/")) {
                return [, "InvalidParameters", new Error("Only image files can be uploaded")];
            }
            if (!Number.isInteger(file.size) || file.size < 1 || file.size > MaxImageSize) {
                return [, "InvalidParameters", new Error(`Image size must be between 1 byte and ${MaxImageSize} bytes`)];
            }
            return [,];
        }
        async initialize() {
            const agreement = this.deps.VersetRequireLoginService.agreement;
            const bucketURI = agreement.particulars.versetWebapp.bucketURI;
            const endpoint = this.deps.VersetRequireLoginService.deps.VersetRequireConnectionService.config.apiEndpoint;
            const apiURL = new URL(endpoint);
            apiURL.protocol = apiURL.protocol === "wss:" ? "https:" : "http:";
            apiURL.pathname = "";
            apiURL.search = "";
            apiURL.hash = "";
            const apiOrigin = apiURL.toString();
            const content = new practice_cps_web_1.ContentPersistentClient({
                contentPersistLayer: this.server.rpcs.ContentPersistLayerService,
                transfer: new practice_cps_web_1.R2HmacTransfer(),
                bucketURI,
                access: {
                    routes: {
                        src: new URL("/cpl/content", apiOrigin).toString(),
                        thumb: new URL("/cpl/content/thumb", apiOrigin).toString(),
                    },
                },
            });
            const [, accessReason, ...accessErrors] = await content.refreshAccess();
            if (accessReason) {
                throw accessErrors[0] || new Error(`Failed to exchange CPL browser access: ${accessReason}`);
            }
            this.content = content;
            const bucket = cps_consensus_1.CPSProtocol.BucketURI.parse(bucketURI);
            cps_consensus_1.BucketHttpAccessProviderRegistryMechanism.single({
                uri: bucketURI,
                single: () => content,
            });
            cps_consensus_1.BucketHttpAccessProviderRegistryMechanism.register({
                name: `${agreement.vendor}+bucket+content`,
                registry: ({ uri }) => {
                    // Preview and tool callers resolve the bucket URI, not only content URIs.
                    const contentInfo = cps_consensus_1.CPSProtocol.BucketURILike.parse(uri);
                    if (!contentInfo || !bucket || contentInfo.vendor !== agreement.vendor
                        || contentInfo.bucketId !== bucket.bucketId && contentInfo.bucketId !== verset_consensus_1.VersetProtocol.OfficialBucketId) {
                        return null;
                    }
                    return content;
                },
            });
        }
        async refreshAccess() {
            return this.content.refreshAccess();
        }
        async uploadImage(file) {
            const [, validationReason, ...validationErrors] = this.assertImageFile(file);
            if (validationReason) {
                return [, validationReason, ...validationErrors];
            }
            const [result, reason, ...errors] = await this.content.upload({
                src: file,
                filename: file.name || undefined,
                mime: file.type,
                name: file.name || undefined,
                size: file.size,
            });
            if (reason || !result?.receipt?.uri) {
                return [, reason || "IOError", ...errors];
            }
            return [{ uri: result.receipt.uri }];
        }
        getImageThumbnailURL(option) {
            return this.content.thumbnail(option);
        }
        getImageContentURL(option) {
            return this.content.src(option);
        }
    };
    return VersetBucketService = _classThis;
})();
exports.VersetBucketService = VersetBucketService;
